import React, {Component} from 'react'

class TableHeader extends Component {
    render() {
        return (
            <thead className='TableHeader'>
                <tr>
                    <th className="groupPrint text-center">Trạng thái</th>
                    <th className="groupPrint text-center">Số lô</th>
                    <th className="groupPrint text-center">Tổng số item</th>
                    <th className="groupTransfer first text-center">Trạng thái</th>
                    <th className="groupTransfer text-center">Số lô</th>
                    <th className="groupTransfer text-center">Tổng số item</th>
                    <th className="groupSew first text-center">Trạng thái</th>
                    <th className="groupSew text-center">Số lô</th>
                    <th className="groupSew text-center">Tổng số item</th>
                </tr>
            </thead>
        )
    }
}

export default TableHeader